import { API_ENDPOINT_ALL_SOURCES } from "src/helpers/endpoint-urls";
import apiClient from "../helpers/api-client";

export const getSources = async () => {
  try {
    return await apiClient.get(API_ENDPOINT_ALL_SOURCES);
  } catch (_e) {
    throw _e;
  }

  // return await apiClient.get(API_ENDPOINT_ALL_CATEGORIES).then((data: any) => {
  //   const result = data?.data ? _.sortBy(data?.data, "category") : [];

  //   return result;
  // });
};
